/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ERC725X, ERC725XInterface } from "../ERC725X";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "operation",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "ContractCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "operation",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "Executed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_operation",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "execute",
    outputs: [
      {
        internalType: "bytes",
        name: "result",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ERC725X__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _newOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC725X> {
    return super.deploy(_newOwner, overrides || {}) as Promise<ERC725X>;
  }
  getDeployTransaction(
    _newOwner: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_newOwner, overrides || {});
  }
  attach(address: string): ERC725X {
    return super.attach(address) as ERC725X;
  }
  connect(signer: Signer): ERC725X__factory {
    return super.connect(signer) as ERC725X__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC725XInterface {
    return new utils.Interface(_abi) as ERC725XInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC725X {
    return new Contract(address, _abi, signerOrProvider) as ERC725X;
  }
}
